import { connect } from 'react-redux';
import { getFormFieldErrorsFromResponseJSON } from 'app/react/helpers/_index';
import { enhanceStateWithHelpers } from 'app/react/entities/enhanceStateWithHelpers';
import * as actions from 'app/react/state/actions/_index';
import Modal from 'app/react/views/account/settings/artists/items/components/groups/GroupModal';
import * as State from './GroupModalState';
import * as ItemGroup from 'app/react/entities/events/artists/item_groups/index';

const FAILED_POPUP = 'Failed to create group.';
const SUCCESSFUL_POPUP = 'Group successfully created.';

const mapStateToProps = (state) => {
    const { helpers } = enhanceStateWithHelpers(state);
    const { eventArtistItemGroups } = helpers;

    const {
        isOpened,
        isSaving,
        values = {},
        errors = {},
    } = State.getCreateModalState(state);

    return {
        eventId: state.currentContext.eventId,
        isCreating: true,
        isOpened,
        values,
        errors,
        isSaving,
        groups: eventArtistItemGroups.getAllForCurrentContext()
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onSave: (createAnother) => {
        const { values, groups } = stateProps;
        dispatchProps.onSave(createAnother, values, groups);
    }
});

const mapDispatchToProps = (dispatch) => ({
    onClosed: () => {
        dispatch((State.setCreateModalStateValue('isOpened', false)));
    },
    onChangeValue: (key, value) => {
        dispatch(State.setCreateModalStateValue(`values.${key}`, value));
    },
    onSave: (createAnother = false, values, groups) => {
        dispatch((State.setCreateModalStateValue('isSaving', true)));
        const apiValues = ItemGroup.schemas.toAPI(values, groups);
        dispatch(ItemGroup.thunks.createOneForCurrentContext(apiValues))
            .then(({ error, response }) => {
                if (typeof error !== 'undefined') {
                    const errors = getFormFieldErrorsFromResponseJSON(error);
                    dispatch(actions.showErrorPopup(FAILED_POPUP));
                    dispatch(State.mergeCreateModalState({
                        errors: errors,
                        isSaving: false
                    }));
                } else {
                    dispatch(actions.showSuccessPopup(SUCCESSFUL_POPUP));
                    dispatch(State.mergeCreateModalState({
                        errors: {},
                        values: {},
                        isOpened: createAnother,
                        isSaving: false
                    }));
                }
            });
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Modal);
